import React from 'react';
import CategoryNavigationButtons from '../game/CategoryNavigationButtons';
import { StockCategoryFilter } from '../../types/stockCategories';

interface SubFooterProps {
  currentCategory: StockCategoryFilter;
}

export const SubFooter: React.FC<SubFooterProps> = ({ currentCategory }) => {
  return (
    <div className="border-t border-gray-300 dark:border-border">
      <div className="container mx-auto max-w-screen-xl px-6 sm:px-8 py-6 space-y-4">
        <CategoryNavigationButtons
          currentCategory={currentCategory}
          showMessage={false}
        />
      </div>
    </div>
  );
};
